import React from 'react'

import classnames from 'classnames'
import PropTypes from 'prop-types'

import AirDna from 'src/Components/homeowners/AirDna'
import CashOut from 'src/Components/homeowners/CashOut'
import Dashboard from 'src/Components/shared/Dashboard'
import EstimatedValue from 'src/Components/shared/EstimatedValue'
import HomeInsuranceCard from 'src/Components/homeowners/HomeInsuranceCard'
import InterestSection from 'src/Components/shared/InterestSection'
import MortgageInsurance from 'src/Components/homeowners/MortgageInsurance'
import Mortgages from 'src/Components/homeowners/Mortgages'
import NoLoansPanel from 'src/Components/homeowners/NoLoansPanel'
import PurchasingPower from 'src/Components/homeowners/PurchasingPower'
import ReverseMortgagesPanel from 'src/Components/homeowners/ReverseMortgagesPanel'
import ShareCta from 'src/Components/homeowners/ShareCta'

import styles from './HomeownerDashboard.module.scss'

const HoDash = ({ className, ...restProps }) => (
  <Dashboard
    className={classnames(className, styles.dashboard)}
    {...restProps}
  />
)

const hoDashPropTypes = { className: PropTypes.string }

const propTypes = {
  className: PropTypes.string,
  loanFocus: PropTypes.bool,
  openLoans: PropTypes.func,
  disableAnimate: PropTypes.bool,
  closeLoans: PropTypes.func,
  delayedRender: PropTypes.bool,
  subdue: PropTypes.bool
}

const HomeownerDashboard = ({
  className,
  loanFocus,
  openLoans,
  disableAnimate,
  closeLoans,
  delayedRender,
  subdue
}) => (
  <div
    className={classnames(
      styles.stage,
      !delayedRender && styles.loading,
      disableAnimate && styles.disableAnimate,
      loanFocus && styles.loanFocus,
      subdue && styles.subdue
    )}
  >
    <HoDash
      data-qa='HomeownersDashboardLeft'
      className={styles.left}
      onClick={openLoans}
      onFocus={openLoans}
    >
      <Mortgages />
    </HoDash>
    <HoDash
      data-qa='HomeownersDashboardRight'
      className={styles.right}
      onClick={closeLoans}
      onFocus={closeLoans}
    >
      <EstimatedValue withCurrentHomeData />
      <NoLoansPanel />
      <HomeInsuranceCard />
      <ReverseMortgagesPanel />
      <InterestSection withCurrentHomeData />
      <PurchasingPower />
      <CashOut />
      <AirDna />
      <MortgageInsurance />
      <ShareCta />
    </HoDash>
  </div>
)

HomeownerDashboard.propTypes = propTypes
HoDash.propTypes = hoDashPropTypes

export default HomeownerDashboard
